import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@components/common';

class DetailItem extends Component {
	shouldComponentUpdate = ({
		label, value, imageUrl, name, shortAddress, firstItem,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.label, label)
			|| !isEqual(lastProps.value, value)
			|| !isEqual(lastProps.imageUrl, imageUrl)
			|| !isEqual(lastProps.name, name)
			|| !isEqual(lastProps.shortAddress, shortAddress)
			|| !isEqual(lastProps.firstItem, firstItem)
		);
	}

	render() {
		const {
			label, value, imageUrl, name, shortAddress, firstItem,
		} = this.props;
		return (
			<Row className={classNames('margin-bottom-15', { 'margin-top-20' : firstItem })}>
				<Col
					md={2}
				>
					<span className="font-size-14 color-gray-dove">{label}</span>
				</Col>
				<Col
					md={10}
				>
					<Choose>
						<When condition={value}>
							<span className="font-size-14 color-gray-mine-shaft">{value}</span>
						</When>
						<Otherwise>
							<Choose>
								<When condition={name}>
									<div className="flex">
										<Image
											className="height-30 width-30 border-radius-15 margin-right-10 margin-top-5 img-cover"
											src={imageUrl || ''}
											fallbackSrc="avatar"
										/>
										<p className="margin-bottom-0 width-170">
											<span className="font-size-15 color-gray-mine-shaft display-block">{ name }</span>
											<span className="font-size-14 color-gray-dove">{ shortAddress }</span>
										</p>
									</div>
								</When>
								<Otherwise>
									<span className="font-size-15 color-gray-mine-shaft display-block">Unspecified</span>
								</Otherwise>
							</Choose>
						</Otherwise>
					</Choose>
				</Col>
			</Row>
		);
	}
}

DetailItem.propTypes = {
	label        : PropTypes.string,
	value        : PropTypes.string,
	imageUrl     : PropTypes.string,
	name         : PropTypes.string,
	shortAddress : PropTypes.string,
	firstItem    : PropTypes.bool,

};

DetailItem.defaultProps = {
	label        : '',
	value        : '',
	imageUrl     : '',
	name         : '',
	shortAddress : '',
	firstItem    : false,
};

export default DetailItem;
